import { cn } from "lib/utils";

export const getObjectValues = (
  capability,
  key,
  isProducts = false,
  isPublic = false,
  productsOnlyLevel2 = []
) => {
  if (!capability || !capability[key] || capability[key]?.length === 0)
    return [];

  const processedLevel2 = new Set();

  return capability[key]
    ?.map((p) => {
      const isOnlyLevel2 = productsOnlyLevel2.some(
        (e) => e.level3 === p.level3
      );

      if (isProducts) {
        if (isOnlyLevel2 && processedLevel2.has(p.level2)) {
          return null;
        }

        if (isOnlyLevel2) {
          processedLevel2.add(p.level2);
        }

        const productValue = isOnlyLevel2 && !isPublic ? p.level2 : p.level3;

        return {
          value: productValue,
          label: productValue,
          id: isOnlyLevel2 && !isPublic ? undefined : p.id,
          name: productValue,
          level3: !isPublic ? productValue : p.level3,
          level2: p.level2,
          level1: p.level1,
          ...(isPublic ? {} : { division: p.division }),
        };
      } else {
        return {
          value: p.name.replace(/ /g, "-").toLowerCase(),
          label: p.name,
          id: p.id,
          name: p.name,
        };
      }
    })
    .filter(Boolean);
};

export const getPrevSelectValue = (
  originalProducts,
  product,
  key,
  all_data
) => {
  const { id, area } = product;
  const row = originalProducts?.find((e) => e.id === id && e.area === area);
  return (
    row &&
    row[key]
      ?.map((e) => {
        return all_data.find((s) => s.id === e.id)?.label || "";
      })
      ?.join("; ")
  );
};

export const getAllProductsByLevel = (products, currentArea) => {
  return products
    ?.filter((el) => el.level1 === currentArea.level1)
    .reduce((res, area) => {
      area?.level2.forEach((s) => {
        s?.level3?.forEach((p) => {
          res.push({
            value: p.name,
            label: p.name,
            id: p.id,
            name: p.name,
            level3: p.name,
            level1: area.level1,
            level2: s.name,
            ...(area.division ? { division: area.division } : {}),
          });
        });
      });
      return res;
    }, []);
};

export const formatAndSort = (arr = [], sort = true) => {
  if (sort) {
    return arr
      ?.map((l) => {
        const value = l?.name?.replace(/ /g, "-")?.toLowerCase();
        return { value, label: l?.name, id: l?.id, name: l?.name };
      })
      ?.sort((a, b) => a?.label?.localeCompare(b?.label));
  } else {
    return arr?.map((l) => {
      const value = l?.name?.replace(/ /g, "-")?.toLowerCase();
      return { value, label: l?.name, id: l?.id, name: l?.name };
    });
  }
};

export const getServiceCapabType = (type) => {
  switch (type) {
    case "Consulting Services Partner":
      return {
        label: "Consulting Services Partner",
        value: "CONSULTING_SERVICES",
      };
    case "Education & Training Partner":
      return {
        label: "Authorized Training Partner",
        value: "EDUCATION_DELIVERY",
      };
    case "Tech Support Partner":
      return {
        label: "Authorized Support Services Partner",
        value: "TECH_SUPPORT_PARTNER",
      };
  }
};

export const getServiceCapabTypeFromValue = (type) => {
  switch (type) {
    case "CONSULTING_SERVICES":
      return { label: "Consulting Services", value: "CONSULTING_SERVICES" };
    case "EDUCATION_DELIVERY":
      return {
        label: "Authorized Training Partner",
        value: "EDUCATION_DELIVERY",
      };
    case "TECH_SUPPORT_PARTNER":
      return {
        label: "Authorized Support Services Partner",
        value: "TECH_SUPPORT_PARTNER",
      };
  }
};

export const getAdditionalInfoPartnerTypeFromValue = (type) => {
  switch (type) {
    case "CONSULTING_SERVICES":
      return {
        label: "Consulting Services Partner",
        value: "CONSULTING_SERVICES",
      };
    case "EDUCATION_DELIVERY":
      return {
        label: "Education & Training Partner",
        value: "EDUCATION_DELIVERY",
      };
    case "TECH_SUPPORT_PARTNER":
      return {
        label: "Tech Support Partner",
        value: "TECH_SUPPORT_PARTNER",
      };
  }
};

export const getStyleByServiceCabapType = (type) => {
  switch (type) {
    case "CONSULTING_SERVICES":
      return cn("bg-[#674E90] border-[#674E90]");
    case "EDUCATION_DELIVERY":
      return cn("bg-[#DB8F40] border-[#DB8F40]");
    case "TECH_SUPPORT_PARTNER":
      return cn("bg-[#34798A] border-[#34798A]");
  }
};

export const getPublicStyleByServiceCabapType = (type) => {
  switch (type) {
    case "CONSULTING_SERVICES":
      return cn("!text-[#674E90]");
    case "EDUCATION_DELIVERY":
      return cn("!text-[#DB8F40]");
    case "TECH_SUPPORT_PARTNER":
      return cn("!text-[#34798A]");
  }
};

export const mandatoryTypes = [
  "CONSULTING_SERVICES",
  "TECH_SUPPORT_PARTNER",
  "EDUCATION_DELIVERY",
];
